import { render } from "./NotificationHeader.vue?vue&type=template&id=7f3f302e&scoped=true"
const script = {}

import "./NotificationHeader.vue?vue&type=style&index=0&id=7f3f302e&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3f302e"]])

export default __exports__